import { Paper, Typography } from '@mui/material';

import AgentsTable from './AgentsTable';

const Agents = () => {
  return (
    <Paper sx={{ mb: 3 }}>
      <Typography variant="h1" sx={{ pb: 3 }}>
        Agents
      </Typography>
      <AgentsTable />
    </Paper>
  );
};

export default Agents;
